import React, { useState } from 'react';
import SearchHeader from './components/SearchHeader';
import LotCard from './components/LotCard';
import FlashSaleButton from './components/FlashSaleButton';
import SaleModal from './components/SaleModal';
import { useLots } from '../../../../../../contexts/LotsContext';

const LotsSelection = ({ onBack, onSaleConfirmed }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [showPrices, setShowPrices] = useState(true);
  const [selectedLot, setSelectedLot] = useState(null);
  const { lots } = useLots();

  // Filtrar lotes disponibles y relámpago
  const filteredLots = lots.filter(lot => {
    // Verificar si el lote está disponible para venta
    const isAvailable = lot.status !== 'closed' && !lot.deleted_at;
    const hasStock = lot.quantity > 0;
    const isLightning = lot.status === 'lightning';
    
    // Aplicar filtro de búsqueda
    const matchesSearch = searchTerm === '' || 
      lot.title?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      lot.supplier?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      lot.display_id?.toLowerCase().includes(searchTerm.toLowerCase());

    return (isLightning || (isAvailable && hasStock)) && matchesSearch;
  });

  const handleCreateFlashSale = () => {
    setSelectedLot({
      is_lightning_lot: true,
      title: '',
      available: 0,
      unit: 'unidades'
    });
  };

  const handleConfirmSale = (saleData) => {
    onSaleConfirmed(saleData);
    setSelectedLot(null);
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <SearchHeader 
        searchTerm={searchTerm}
        onSearchChange={setSearchTerm}
        showPrices={showPrices}
        onTogglePrices={() => setShowPrices(!showPrices)}
        onBack={onBack}
      />

      <div className="p-4 space-y-4">
        <FlashSaleButton onClick={handleCreateFlashSale} />
        
        <div className="space-y-3">
          {filteredLots.map((lot) => (
            <LotCard
              key={lot.id}
              lot={lot}
              showPrices={showPrices}
              onSelect={() => setSelectedLot(lot)}
            />
          ))}

          {filteredLots.length === 0 && (
            <div className="text-center text-gray-500 dark:text-gray-400 py-8">
              No hay lotes disponibles
            </div>
          )}
        </div>
      </div>

      {selectedLot && (
        <SaleModal
          lot={selectedLot}
          onClose={() => setSelectedLot(null)}
          onConfirm={handleConfirmSale}
        />
      )}
    </div>
  );
};

export default LotsSelection; 